module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "px3 mt4"
  }, [_c('h1', {
    staticClass: "m0 center",
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex mt3 flex-wrap"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('a', {
    staticClass: "twitter-timeline",
    attrs: {
      "data-dnt": "true",
      "href": "https://twitter.com/hashtag/stop_e40",
      "data-widget-id": "899317276876394496"
    }
  }, [_vm._v("#stop_e40 Tweets")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a830a7d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialFeeds.vue
// module id = 123
// module chunks = 0